module.exports = __webpack_public_path__ + "img/arrow-swap-horizontal.8893e2b9.svg";